/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
export class CountryListForm {
    public limit: number;
    public offset: number;
    public keyword: string;
    public sortOrder: string;
    public count: number;
    public status: number;

    constructor(countrylistForm: any) {
      this.limit = countrylistForm.limit || 0;
      this.offset = countrylistForm.offset || 0;
      this.keyword = countrylistForm.keyword || '';
      this.count = countrylistForm.count || 0;
      this.status = countrylistForm.status;

    }
  }
